import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden" aria-label="行动号召">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20living%20space%20with%20premium%20quality%20home%20products%2C%20soft%20natural%20lighting%2C%20cream%20beige%20and%20warm%20wood%20tones%2C%20peaceful%20cozy%20atmosphere%2C%20elegant%20editorial%20photography%2C%20high%20quality%20composition&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-[700px] mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-3 md:mb-4">
          选择久久久，选择长久信赖
        </h2>
        <p className="text-white/75 text-sm md:text-base leading-relaxed mb-8 md:mb-10">
          无论您寻求的是经久耐用的产品还是持续有效的服务，久久久都为您提供经得起时间检验的优质体验，让每一次选择都值得长久信赖。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/home-living"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-white text-foreground-950 font-medium text-sm hover:bg-white/90 transition-all duration-300 cursor-pointer"
          >
            立即探索产品
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}